define.alias("shared/components/shared/post/secondary/hashtag-suggestions/error", "preview-grid/components/shared/post/secondary/hashtag-suggestions/error");